export default __webpack_public_path__ + "static/media/ICON1.9a5484a2.png";